<template>
  <div class="container">
    <div class="leftListOne">
            <div class="leftListOne_top">
              <span class="leftListOne_top_text">承灾体信息 <span class="leftListOne_top_more" @click="ahMore('承灾体信息')">更多》</span> </span>
            </div>
            <div class="leftListOneconBox">
              <div class="leftListOneCon">
                  <div class="leftListOneCon_top">
                      <img src="@/assets/images/population.png" alt="" class="population" />
                      <span class="leftListOneCon_top_people">人口</span>
                  </div>
                  <span class="leftListOneCon_num">{{IndexDataList.carrierMen}} <span class="leftListOneCon_danw">万人</span> </span>
              </div>
              <div class="leftListOneCon">
                  <div class="leftListOneCon_top">
                      <img src="@/assets/images/architecture.png" alt="" class="population" />
                      <span class="leftListOneCon_top_people">房屋</span>
                  </div>
                  <span class="leftListOneCon_num"> {{IndexDataList.carrierHouse}}<span class="leftListOneCon_danw">座</span> </span>
              </div>
              <div class="leftListOneCon">
                  <div class="leftListOneCon_top">
                      <img src="@/assets/images/facility.png" alt="" class="population" />
                      <span class="leftListOneCon_top_people">基础设施</span>
                  </div>
                  <span class="leftListOneCon_num">{{IndexDataList.carrierBase}} <span class="leftListOneCon_danw">项</span> </span>
              </div>
              <div class="leftListOneCon">
                  <div class="leftListOneCon_top">
                      <img src="@/assets/images/serve.png" alt="" class="population" />
                      <span class="leftListOneCon_top_people">公共服务设施</span>
                  </div>
                  <span class="leftListOneCon_num">{{IndexDataList.carrierPublic}}<span class="leftListOneCon_danw">项</span> </span>
              </div>
              <div class="leftListOneCon">
                  <div class="leftListOneCon_top">
                      <img src="@/assets/images/three.png" alt="" class="population" />
                      <span class="leftListOneCon_top_people">三次产业</span>
                  </div>
                  <span class="leftListOneCon_num">{{IndexDataList.carrierThird}}<span class="leftListOneCon_danw">项</span> </span>
              </div>
              <div class="leftListOneCon">
                  <div class="leftListOneCon_top">
                      <img src="@/assets/images/resource.png" alt="" class="population" />
                      <span class="leftListOneCon_top_people">资源与环境</span>
                  </div>
                  <span class="leftListOneCon_num">{{IndexDataList.carrierEnv}} <span class="leftListOneCon_danw">项</span> </span>
              </div>
            </div>
    </div>
    <div class="leftListOne">
    <div class="leftListOne_top">
        <span class="leftListOne_top_text">减灾能力分析<span class="leftListOne_top_more" @click="ahMore('减灾能力分析')">更多》</span></span>
    </div>
    <div class="leftListTwo">
        <div class="leftListTwo_one animate__animated  animate__pulse animate__slower 5s animate__infinite infinite">
            社会
        </div>
        <div class="leftListOne_num">
            <span class="leftListone_num_bai">{{IndexDataList.analysisSoc}}%</span>
        </div>
        <div class="leftListTwo_two animate__animated  animate__pulse animate__slower 5s animate__infinite infinite">
            政府
        </div>
        <div class="leftListTwo_num">
            <span class="leftListTwo_num_bai">{{IndexDataList.analysisGov}}%</span>
        </div>
        <div class="leftListTwo_three animate__animated  animate__pulse animate__slower 5s animate__infinite infinite">
            基层
        </div>
        <div class="leftListThree_num">
            <span class="leftListThree_num_bai">{{IndexDataList.analysisBase}}%</span>
        </div>
    </div>
    </div>
    <div class="leftListOne">
    <div class="leftListOne_top">
        <span class="leftListOne_top_text">风险区域
          <!-- <span class="leftListOne_top_more" @click="fxqymore">更多》</span> -->
        </span>
    </div>
    <!-- <div id="line" style="width: 400px; height: 15vw"></div> -->
        <!-- 饼图 -->
    <div class="container" v-if="IndexDataList.areaHigh+IndexDataList.areaMid+IndexDataList.areaLow+IndexDataList.areaWater+IndexDataList.areaOther==0">
        <img src="@/assets/images/nonumb.png" alt="" style="width:100%;">
    </div>
    <div class="container" v-else>
        <div class="chartsGl" id="charts"></div>
        <!-- 饼图下面的底座 -->
        <div class="buttomCharts"></div>
    </div>

    </div>
    <!-- 减灾能力分析 -->
    <el-dialog
        title=""
        :visible.sync="dialogVisibleShow"
        width="70%"
        top="7vh"
        :append-to-body="true">
        <div class="shopTc">
            <span class="shopTc_tit">{{tcName}} <i class="el-icon-circle-close shopTc_show" @click="shopShowClose"></i> </span>
            <div class="jztab">
                <el-radio-group v-model="jzradio" @change="jztantab">
                  <el-radio :label="1" style="color:#fff;">表单展示</el-radio>
                  <el-radio :label="2"  style="color:#fff;">图表展示</el-radio>
                </el-radio-group>
            </div>
            <div v-if="biaodan==false">
                <div class="shopTc_con" style="margin-bottom:1vw;">
                  <span class="shopTc_zttit">主体类型</span>
                  <el-select v-model="valueLa" @change="changeLa" clearable placeholder="请选择">
                    <el-option
                      v-for="item in optionsLa"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      >
                    </el-option>
                  </el-select>
                  <span class="shopTc_zttit">主体名称</span>
                  <el-input
                    placeholder="请输入内容"
                    v-model="inputTop"
                    style="width:25%;"
                    @input="inputLa"
                    clearable>
                  </el-input>
                  <el-button style="margin-left:1%;" type="warning" size="small" icon="el-icon-refresh" @click="resetting">重 置</el-button>
                  <el-button style="margin-left:1%;" type="warning" size="small"  @click="ahMore('颍上县')">全部信息</el-button>
                  <el-button style="margin-left:1%;" type="warning" size="small"  @click="ahMore('承灾体信息')">承灾体</el-button>
                  <el-button style="margin-left:1%;" type="warning" size="small"  @click="ahMore('减灾能力分析')">减灾能力</el-button>
                  <span class="zongji">总计 <span class="zongji_Num">{{total}}</span> 条</span>
                </div>
                <el-table
                  :data="tableDataTwo"
                  height="485"
                  style="width: 96%;margin:0 auto;">
                  <el-table-column
                    type="index"
                    label="#"
                    align="center"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    prop="buildingTypeName"
                    label="主体类型"
                    width="240">
                  </el-table-column>
                  <el-table-column
                    prop="buildingInfoName"
                    label="主体名称"
                    width="420">
                  </el-table-column>
                  <el-table-column
                    prop="totalMen"
                    label="统计负责人"
                    align="center"
                    width="140">
                  </el-table-column>
                  <el-table-column
                    prop="fillMen"
                    label="填表人"
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="填表日期"
                    width="150"
                    >
                    <template slot-scope="scope">
                    <span slot="reference" >{{scope.row.fillTime.substr(0, 10) }}</span>
                    </template>
                    
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                      <el-button @click="handleClick(scope.row)" type="text" size="small" style="color:#00A8A4;font-size:14px;">
                        <i class="el-icon-view"></i>
                        查看
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="shopTc_bottom tccom">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="current"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                  </el-pagination>
                </div>
            </div>
            <div v-else ref="jgjcEchart" style="width:94%;height: 560px;margin-left:3%;"></div>
        </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisibleShop" width="70%" top="7vh" :append-to-body="true">
      <div class="shopTc">
        <span class="shopTc_tit">{{name}} <i class="el-icon-circle-close shopTc_show" @click="shopShowClose2"></i>
        </span>
        <div class="shopTc_con">
          <span class="shopTc_con_name">企业名称： <span style="color:#E0E0E0;">{{name}}</span> </span>
          <span class="shopTc_con_name">详细地址： <span style="color:#E0E0E0;">{{address}}</span> </span>
        </div>
        <el-table :data="tableData" height="485" border style="width: 96%;margin:0 auto;">
          <el-table-column prop="name" label="指标名称" width="360">
          </el-table-column>
          <el-table-column prop="itemCode" label="代码" align="center" width="80">
          </el-table-column>
          <el-table-column prop="itemValue" label="填报值">
          </el-table-column>
        </el-table>
        <div class="shopTc_bottom">
          <span class="shopTc_bottom_name">单位负责人： <span style="color:#E0E0E0;">{{headMen}}</span> </span>
          <span class="shopTc_bottom_name">填表人： <span style="color:#E0E0E0;">{{fillMen}}</span> </span>
          <span class="shopTc_bottom_name">联系电话： <span style="color:#E0E0E0;">{{mobilePhone}}</span> </span>
          <span class="shopTc_bottom_name">报出日期： <span style="color:#E0E0E0;">{{fillTime}}</span> </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title=""
        :visible.sync="dialogVisibleFxqy"
        width="70%"
        top="7vh"
        :append-to-body="true">
        <div class="shopTc">
            <span class="shopTc_tit">风险区域 <i class="el-icon-circle-close shopTc_show" @click="shopShowClose"></i> </span>
            <div class="shopTc_con" style="margin-bottom:1vw;">
              <span class="shopTc_zttit">主体类型</span>
              <el-select v-model="valueLa" @change="changeFxLa" clearable placeholder="请选择">
                <el-option
                  v-for="item in optionsfxLa"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  >
                </el-option>
              </el-select>
              <span class="shopTc_zttit">主体名称</span>
              <el-input
                placeholder="请输入内容"
                v-model="inputfxTop"
                style="width:25%;"
                @input="inputfxLa"
                clearable>
              </el-input>
            </div>
            <el-table
              :data="tableDataFx"
              height="485"
              style="width: 96%;margin:0 auto;">
              <el-table-column
                type="index"
                label="#"
                align="center"
                width="50">
              </el-table-column>
              <el-table-column
                prop="riskLevelName"
                label="主体类型"
                width="400">
              </el-table-column>
              <el-table-column
                prop="name"
                label="主体名称"
                width="660">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色值"
                align="center"
                width="120">
              </el-table-column>
            </el-table>
            <div class="shopTc_bottom tccom">
              <el-pagination
                @size-change="handleSizefxChange"
                @current-change="handleCurrentfxChange"
                :current-page="current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
        </div>
    </el-dialog>
    
  </div>
</template>
 
<script>
import "echarts-gl";
import * as echarts from 'echarts';
import { querySimpleDataListForRiskLevel, queryIndexData, queryBuildingTypeSimpleDataList, querySurveyTableListForScreen, querySurveyRecoredById, queryAreaInfoList,queryJianzainengli,queryDivisionInfo } from '@/api';
window._AMapSecurityConfig = {
    securityJsCode: '9717000b582173f89bc34178c30f8837',
}
export default {
  props:{
    filterList:Array,
  },
  name: 'MyComponent',
  data () {
    return {
       dialogVisibleShow:false,
       dialogVisibleFxqy:false,
       dialogVisibleShop:false,
       optionsLa:[],
       optionsfxLa:[],
      tableDataTwo: [],
      tableDataFx:[],
      tableData: [],
      valueLa: '',
      inputTop:'',
      inputfxTop:'',
      current: 1,
      size:10,
      IndexDataList:'',
      total:0,
      riskLevel:0,
      address:'',
      name:'',
      headMen:'',
      fillMen:'',
      mobilePhone:'',
      fillTime:'',
      tcName:'',
      //饼图数据+颜色
      jzradio:1,
      biaodan:false,
      // 减灾能力图表
      xZhou:[],
      yjksrs:[],
      rkval:[],
      cyjyrs:[],
      timer:null,
      divisionInfoId:'',
    }
  },
  created(){
    this.queryIndexDataApi();
    this.queryBuildingTypeSimpleDataListApi()
    this.queryJianzainengliApi()
  },
  watch:{
    filterList(newVal,oldVal){
      let divId = newVal[0].id
      queryDivisionInfo(divId).then(res=>{
        this.IndexDataList = res.data.screenSettingDTO
        setTimeout(() => {
          this.init(this.IndexDataList);
        }, 100);
        
      })
    }
  },
   mounted() {},
  methods:{
    // 减灾模式切换
    jztantab(val){
      if (val=='2') {
        this.biaodan = true
        setTimeout(() => {
          this.initjianz()
        }, 400);
        
      }else{
        this.biaodan = false
      }
    },
    resetting(){
      this.valueLa = '';
      this.inputTop = '';
      this.queryBuildingTypeSimpleDataListApi();
      this.inputLa();
    },
    queryIndexDataApi(){
      queryIndexData().then(res=>{
        this.IndexDataList = res.data
        this.init(this.IndexDataList);
      })
    },
    queryBuildingTypeSimpleDataListApi(){
      queryBuildingTypeSimpleDataList().then(res=>{
        this.optionsLa = res.data
      })
    },
    openDialog(id,name) {
      this.divisionInfoId = id
      this.tcName = name
      if (id) {
        this.querySurveyTableListForScreenApi()
      }
      this.dialogVisibleShow = true
    },
    querySurveyTableListForScreenApi(){
      querySurveyTableListForScreen({
        buildingInfoName:'',
        buildingTypeId:'',
        current:this.current,
        size:this.size,
        isBuildingType:this.isBuildingType,
        divisionInfoId:this.divisionInfoId,
      }).then(res=>{
        this.tableDataTwo = res.data.records
        this.total = res.data.total
      })
    },
    queryAreaInfoListApi(){
      queryAreaInfoList({
        name:'',
        riskLevel:this.riskLevel,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    querySimpleDataListForRiskLeveltApi(){
      querySimpleDataListForRiskLevel().then(res=>{
        this.optionsfxLa = res.data
      })
    },
    // 减灾能力柱状图
    queryJianzainengliApi(){
      queryJianzainengli().then(res=>{
        this.xZhou = res.data.map(val=>val.name)
        this.yjksrs = res.data.map(val=>val.admissiblequantity)
        this.rkval = res.data.map(val=>val.carrierMen)
        this.cyjyrs = res.data.map(val=>val.jiuyuanrenshu)
      })
    },
    // 减灾能力图片
    initjianz() {
      var myChart = echarts.init(this.$refs.jgjcEchart)
      let option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(33, 85, 154, .6)',
            borderWidth: 1,
            borderColor: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
              {
                offset: 0,
                color: 'rgba(85, 149, 233, .6)' // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(85, 149, 233, 0)' // 100% 处的颜色
              }
              ],
              global: false // 缺省为 false
            },
            padding: 8,
            textStyle: {
              color: '#fff'
            },
            axisPointer: {
              lineStyle: {
              type: 'dashed',
              color: 'rgba(255, 255, 255, .6)'
              }
            },
            extraCssText: 'box-shadow: 2px 2px 16px 1px rgba(0, 39, 102, 0.16)',
            formatter: function (params) {
              let content = `<div style='font-size: 14px; color: #fff;'>${params[0].name}</div>`
              if (Array.isArray(params)) {
              for (let i = 0; i < params.length; i++) {
                content += `
                  <div style='display: flex; align-items: center; padding: 4px; background: #21559A; margin-top: 4px; color: #fff;'>
                    <div style='width: 10px; height: 10px; background: ${params[i].color}; margin-right: 8px;'></div>
                    <div style='font-size: 12px; margin-right: 32px;'>${params[i].seriesName}</div>
                    <div style='font-size: 14px;'>${params[i].value}</div>
                  </div>
                  `
              }
              }
              return content
            }
          },
          legend: {
              data: ['应急可收容数', '人口','参与救援人数'],
              textStyle: {
                color: '#ffffff', // 设置图例文本颜色为红色
              }
          },
          grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
          },
          xAxis: [
              {
                  type: 'category',
                  data: this.xZhou,
                  axisLabel: {
                    color: '#ffffff' // 设置 Y 轴标签字体为绿色
                  }
              }
          ],
          dataZoom: [
              {
                  type: 'slider',
                  show: true,
                  xAxisIndex: [0],
                  left: '5%',
                  start: 0, //数据窗口范围的起始百分比
                  end:100 // 滚动条所占百分比
              },
              {
                  type: 'inside',
                  xAxisIndex: [0],
                  start: 0,
                  end: 36
              }
          ],
          yAxis: [
              {
                  type: 'value',
                  axisLabel: {
                    color: '#ffffff' // 设置 Y 轴标签字体为绿色
                  }
              }
          ],
          series: [
              {
                  name: '应急可收容数',
                  type: 'bar',
                  barWidth: 35,
                  stack: '1',
                  data: this.yjksrs
              },
              {
                  name: '人口',
                  type: 'bar',
                  stack: '1',
                  data: this.rkval
              },
              {
                  name: '参与救援人数',
                  type: 'bar',
                  stack: '1',
                  data: this.cyjyrs
              },
          ]
      };
      // 动态显示tootip
      var faultByHourIndex1 = 0; //播放所在下标
      this.timer = setInterval(() => {
            //使得tootip每隔三秒自动显示
            myChart.dispatchAction({
            type: "showTip", // 根据 tooltip 的配置项显示提示框。
            seriesIndex: 0,
            dataIndex: faultByHourIndex1,
            });
            faultByHourIndex1++;
            if (faultByHourIndex1 >= option.series[0].data.length) {
            faultByHourIndex1 = 0;
            }
        }, 1500);
      myChart.setOption(option);
    },
    //初始化构建
    init(e) {
      let optionData = [
        {
          name: '高风险区域',//名称
          value: e.areaHigh,//值
          itemStyle: {//颜色 紫色
            color: 'rgba(241, 119, 113, 1)'
          }
      }, {
          name: '中风险区域',//蓝色
          value: e.areaMid,
          itemStyle: {
            color: 'rgba( 255, 179, 80, 1)',
          }
      }, {
          name: '低风险区域',//绿色
          value: e.areaLow,
          itemStyle: {
              color: 'rgba(30, 210, 255, 1) '
          }},
          {
          name: '水旱灾害区',//橙色
          value: e.areaWater,
          itemStyle: {
              color: 'rgba(19, 217, 165, 1)'
          }}
          ,
          {
          name: '其他',//黄色
          value: e.areaOther,
          itemStyle: {
              color: 'rgba(139, 159, 239, 1)'
          }}
        ]
        //构建3d饼状图
        let myChart = this.$echarts.init(document.getElementById('charts'));
        // 传入数据生成 option ; getPie3D(数据，透明的空心占比（调节中间空心范围的0就是普通饼1就很镂空）)
        this.option = this.getPie3D(optionData, 0.85);
        //将配置项设置进去
        myChart.setOption(this.option);
        //鼠标移动上去特效效果
      this.bindListen(myChart);
    },
    //配置构建 pieData 饼图数据 internalDiameterRatio:透明的空心占比
    getPie3D(pieData, internalDiameterRatio) {
        let that = this;
        let series = [];
        let sumValue = 0;
        let startValue = 0;
        let endValue = 0;
        let legendData = [];
        let legendBfb = [];
        let k = 1 - internalDiameterRatio;
        pieData.sort((a, b) => {
            return (b.value - a.value);
        });
        // 为每一个饼图数据，生成一个 series-surface(参数曲面) 配置
        for (let i = 0; i < pieData.length; i++) {
            sumValue += pieData[i].value;
            let seriesItem = {
                //系统名称
                name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
                type: 'surface',
                //是否为参数曲面（是）
                parametric: true,
                //曲面图网格线（否）上面一根一根的
                wireframe: {
                    show: false
                },
                pieData: pieData[i],
                pieStatus: {
                    selected: false,
                    hovered: false,
                    k: k
                },
                //设置饼图在容器中的位置(目前没发现啥用)
              //   center: ['50%', '100%']
            };

            //曲面的颜色、不透明度等样式。
            if (typeof pieData[i].itemStyle != 'undefined') {
                let itemStyle = {};
                typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null;
                typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity : null;
                seriesItem.itemStyle = itemStyle;
            }
            series.push(seriesItem);
        }

        // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
        // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
        legendData = [];
        legendBfb = [];
        for (let i = 0; i < series.length; i++) {
            endValue = startValue + series[i].pieData.value;
            series[i].pieData.startRatio = startValue / sumValue;
            series[i].pieData.endRatio = endValue / sumValue;
            series[i].parametricEquation = this.getParametricEquation(series[i].pieData.startRatio, series[i].pieData.endRatio,
                false, false, k, series[i].pieData.value);
            startValue = endValue;
            let bfb = that.fomatFloat(series[i].pieData.value / sumValue, 4);
            legendData.push({
                name: series[i].name,
                value: bfb
            });
            legendBfb.push({
                name: series[i].name,
                value: bfb
            });
        }
        //(第二个参数可以设置你这个环形的高低程度)
        let boxHeight = this.getHeight3D(series, 13);//通过传参设定3d饼/环的高度
        // 准备待返回的配置项，把准备好的 legendData、series 传入。
        let option = {
          //图例组件
            legend: {
                data: legendData,
                //图例列表的布局朝向。
                orient: 'horizontal',
                left: 10,
                top: 150,
                //图例文字每项之间的间隔
                itemGap: 15,
                textStyle: {
                    color: '#A1E2FF',
                },
                show: true,
                icon: "circle",
                //格式化图例文本（我是数值什么显示什么）
                formatter: function (name) {
                  var target;
                  for (var i = 0, l =pieData.length; i < l; i++) {
                      if (pieData[i].name == name) {
                      target = pieData[i].value;
                      }
                  }
                  return `${name}: ${target}`;
                  },
              // 这个可以显示百分比那种（可以根据你想要的来配置）
                formatter: function(param) {
                    let item = legendBfb.filter(item => item.name == param)[0];
                    let bfs = that.fomatFloat(item.value * 100, 1) + "%";
                    return `${item.name} :${bfs}`;
                }
            },
            //移动上去提示的文本内容(我没来得及改 你们可以根据需求改)
            tooltip: {
                formatter: params => {
                    if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
                        let bfb = ((option.series[params.seriesIndex].pieData.endRatio - option.series[params.seriesIndex].pieData.startRatio) *
                            100).toFixed(2);
                        return `${params.seriesName}<br/>` +
                            `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>` +
                            `${ bfb }`;
                    }
                }
            },
            //这个可以变形
            xAxis3D: {
                min: -1,
                max: 1
            },
            yAxis3D: {
                min: -1,
                max: 1
            },
            zAxis3D: {
                min: -1,
                max: 1
            },
            //此处是修改样式的重点
            grid3D: {
                show: false,
                boxHeight: boxHeight, //圆环的高度
                //这是饼图的位置
                top: '-28.5%',
                left:'-1%',
                    viewControl: { //3d效果可以放大、旋转等，请自己去查看官方配置
                    alpha: 16, //角度(这个很重要 调节角度的)
                    distance: 130,//调整视角到主体的距离，类似调整zoom(这是整体大小)
                    rotateSensitivity: 0, //设置为0无法旋转
                    zoomSensitivity: 0, //设置为0无法缩放
                    panSensitivity: 0, //设置为0无法平移
                    autoRotate: true //自动旋转
                }
            },
            series: series
        };
        return option;
    },
    //获取3d丙图的最高扇区的高度
    getHeight3D(series, height) {
        series.sort((a, b) => {
            return (b.pieData.value - a.pieData.value);
        })
        return height * 10 / series[0].pieData.value;
    },
    // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
        // 计算
        let midRatio = (startRatio + endRatio) / 2;
        let startRadian = startRatio * Math.PI * 2;
        let endRadian = endRatio * Math.PI * 2;
        let midRadian = midRatio * Math.PI * 2;
        // 如果只有一个扇形，则不实现选中效果。
        if (startRatio === 0 && endRatio === 1) {
            isSelected = false;
        }
        // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
        k = typeof k !== 'undefined' ? k : 1 / 3;
        // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
        let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
        let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
        // 计算高亮效果的放大比例（未高亮，则比例为 1）
        let hoverRate = isHovered ? 1.05 : 1;
        // 返回曲面参数方程
        return {
            u: {
                min: -Math.PI,
                max: Math.PI * 3,
                step: Math.PI / 32
            },
            v: {
                min: 0,
                max: Math.PI * 2,
                step: Math.PI / 20
            },
            x: function(u, v) {
                if (u < startRadian) {
                    return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
                }
                if (u > endRadian) {
                    return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
                }
                return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
            },
            y: function(u, v) {
                if (u < startRadian) {
                    return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
                }
                if (u > endRadian) {
                    return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
                }
                return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
            },
            z: function(u, v) {
                if (u < -Math.PI * 0.5) {
                    return Math.sin(u);
                }
                if (u > Math.PI * 2.5) {
                    return Math.sin(u) * h * .1;
                }
                return Math.sin(v) > 0 ? 1 * h * .1 : -1;
            }
        };
    },
  //这是一个自定义计算的方法
    fomatFloat(num, n) {
        var f = parseFloat(num);
        if (isNaN(f)) {
            return false;
        }
        f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂   
        var s = f.toString();
        var rs = s.indexOf('.');
        //判定如果是整数，增加小数点再补0
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + n) {
            s += '0';
        }
        return s;
    },
     // 监听鼠标事件，实现饼图选中效果（单选），近似实现高亮（放大）效果。
    bindListen(myChart) {
        let that = this;
        let selectedIndex = '';
        let hoveredIndex = '';
        // 监听点击事件，实现选中效果（单选）
        myChart.on('click', function(params) {
            // 从 option.series 中读取重新渲染扇形所需的参数，将是否选中取反。
            let isSelected = !that.option.series[params.seriesIndex].pieStatus.selected;
            let isHovered = that.option.series[params.seriesIndex].pieStatus.hovered;
            let k = that.option.series[params.seriesIndex].pieStatus.k;
            let startRatio = that.option.series[params.seriesIndex].pieData.startRatio;
            let endRatio = that.option.series[params.seriesIndex].pieData.endRatio;
            // 如果之前选中过其他扇形，将其取消选中（对 option 更新）
            if (selectedIndex !== '' && selectedIndex !== params.seriesIndex) {
                that.option.series[selectedIndex].parametricEquation = that.getParametricEquation(that.option.series[
                        selectedIndex].pieData
                    .startRatio, that.option.series[selectedIndex].pieData.endRatio, false, false, k, that.option.series[
                        selectedIndex].pieData
                    .value);
                that.option.series[selectedIndex].pieStatus.selected = false;
            }
            // 对当前点击的扇形，执行选中/取消选中操作（对 option 更新）
            that.option.series[params.seriesIndex].parametricEquation = that.getParametricEquation(startRatio, endRatio,
                isSelected,
                isHovered, k, that.option.series[params.seriesIndex].pieData.value);
            that.option.series[params.seriesIndex].pieStatus.selected = isSelected;
            // 如果本次是选中操作，记录上次选中的扇形对应的系列号 seriesIndex
            isSelected ? selectedIndex = params.seriesIndex : null;
            // 使用更新后的 option，渲染图表
            myChart.setOption(that.option);
        });
        // 监听 mouseover，近似实现高亮（放大）效果
        myChart.on('mouseover', function(params) {
            // 准备重新渲染扇形所需的参数
            let isSelected;
            let isHovered;
            let startRatio;
            let endRatio;
            let k;
            // 如果触发 mouseover 的扇形当前已高亮，则不做操作
            if (hoveredIndex === params.seriesIndex) {
                return;
                // 否则进行高亮及必要的取消高亮操作
            } else {
                // 如果当前有高亮的扇形，取消其高亮状态（对 option 更新）
                if (hoveredIndex !== '') {
                    // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 false。
                    isSelected = that.option.series[hoveredIndex].pieStatus.selected;
                    isHovered = false;
                    startRatio = that.option.series[hoveredIndex].pieData.startRatio;
                    endRatio = that.option.series[hoveredIndex].pieData.endRatio;
                    k = that.option.series[hoveredIndex].pieStatus.k;
                    // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
                    that.option.series[hoveredIndex].parametricEquation = that.getParametricEquation(startRatio, endRatio,
                        isSelected,
                        isHovered, k, that.option.series[hoveredIndex].pieData.value);
                    that.option.series[hoveredIndex].pieStatus.hovered = isHovered;
                    // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
                    hoveredIndex = '';
                }
                // 如果触发 mouseover 的扇形不是透明圆环，将其高亮（对 option 更新）
                if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
                    // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
                    isSelected = that.option.series[params.seriesIndex].pieStatus.selected;
                    isHovered = true;
                    startRatio = that.option.series[params.seriesIndex].pieData.startRatio;
                    endRatio = that.option.series[params.seriesIndex].pieData.endRatio;
                    k = that.option.series[params.seriesIndex].pieStatus.k;
                    // 对当前点击的扇形，执行高亮操作（对 option 更新）
                    that.option.series[params.seriesIndex].parametricEquation = that.getParametricEquation(startRatio, endRatio,
                        isSelected, isHovered, k, that.option.series[params.seriesIndex].pieData.value + 5);
                    that.option.series[params.seriesIndex].pieStatus.hovered = isHovered;
                    // 记录上次高亮的扇形对应的系列号 seriesIndex
                    hoveredIndex = params.seriesIndex;
                }
                // 使用更新后的 option，渲染图表
                myChart.setOption(that.option);
            }
        });
        // 修正取消高亮失败的 bug
        myChart.on('globalout', function() {
            // 准备重新渲染扇形所需的参数
            let isSelected;
            let isHovered;
            let startRatio;
            let endRatio;
            let k;
            if (hoveredIndex !== '') {
                // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
                isSelected = that.option.series[hoveredIndex].pieStatus.selected;
                isHovered = false;
                k = that.option.series[hoveredIndex].pieStatus.k;
                startRatio = that.option.series[hoveredIndex].pieData.startRatio;
                endRatio = that.option.series[hoveredIndex].pieData.endRatio;
                // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
                that.option.series[hoveredIndex].parametricEquation = that.getParametricEquation(startRatio, endRatio,
                    isSelected,
                    isHovered, k, that.option.series[hoveredIndex].pieData.value);
                that.option.series[hoveredIndex].pieStatus.hovered = isHovered;
                // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
                hoveredIndex = '';
            }
            // 使用更新后的 option，渲染图表
            myChart.setOption(that.option);
        });
    },
    ahMore(e){
      this.tcName = e
      if (this.tcName=='承灾体信息') {
        this.isBuildingType = true
      } else if(this.tcName=='减灾能力分析') {
         this.isBuildingType = false
      }else{
        this.isBuildingType = ''
      }
      this.dialogVisibleShow = true
      this.querySurveyTableListForScreenApi()
    },
    fxqymore(){
      this.dialogVisibleFxqy = true
      this.querySimpleDataListForRiskLeveltApi()
      this.queryAreaInfoListApi()
    },
    shopShowClose(){
      this.divisionInfoId = ''
      this.dialogVisibleShow = false
      this.dialogVisibleFxqy = false
    },
    shopShowClose2(){
      this.dialogVisibleShop = false
      this.dialogVisibleShow = true
    },
    changeLa(e){
      querySurveyTableListForScreen({
        buildingInfoName:'',
        buildingTypeId:e,
        current:this.current,
        size:this.size,
        isBuildingType:this.isBuildingType,
        divisionInfoId:this.divisionInfoId,
      }).then(res=>{
        this.tableDataTwo = res.data.records
        this.total = res.data.total
      })
    },
    changeFxLa(e){
      if (e=='') {
        this.riskLevel = 0
      }else{
        this.riskLevel = e
      }
      queryAreaInfoList({
        name:'',
        riskLevel:this.riskLevel,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    handleSizeChange(val) {
      this.size = val
      querySurveyTableListForScreen({
        buildingInfoName:'',
        buildingTypeId:'',
        current:this.current,
        size:this.size,
        isBuildingType:this.isBuildingType,
        divisionInfoId:this.divisionInfoId,
      }).then(res=>{
        this.tableDataTwo = res.data.records
        this.total = res.data.total
      })
    },
    handleSizefxChange(val){
      this.size = val
      queryAreaInfoList({
        name:'',
        riskLevel:this.riskLevel,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    handleCurrentChange(val) {
      this.current = val
      querySurveyTableListForScreen({
        buildingInfoName:'',
        buildingTypeId:'',
        current:this.current,
        size:this.size,
        isBuildingType:this.isBuildingType,
        divisionInfoId:this.divisionInfoId,
      }).then(res=>{
        this.tableDataTwo = res.data.records
        this.total = res.data.total
      })
    },
    handleCurrentfxChange(val) {
      this.current = val
      queryAreaInfoList({
        name:'',
        riskLevel:this.riskLevel,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    inputLa(val){
      querySurveyTableListForScreen({
        buildingInfoName:val,
        buildingTypeId:'',
        current:this.current,
        size:this.size,
        isBuildingType:this.isBuildingType,
        divisionInfoId:this.divisionInfoId,
      }).then(res=>{
        this.tableDataTwo = res.data.records
        this.total = res.data.total
      })
    },
    inputfxLa(val){
      queryAreaInfoList({
        name:val,
        riskLevel:this.riskLevel,
        current:this.current,
        size:this.size,
      }).then(res=>{
        this.tableDataFx = res.data.records
        this.total = res.data.total
      })
    },
    handleClick(val){
      let surveyTableId = val.id
      querySurveyRecoredById(surveyTableId).then(res=>{
        console.log(`当前: ${res}`);
        if (res.code==200) {
          this.address = res.data.address
          this.name = res.data.name
          this.headMen = res.data.headMen
          this.fillMen = res.data.fillMen
          this.mobilePhone = res.data.mobilePhone
          this.fillTime = res.data.fillTime
          this.tableData = res.data.fillItemList
        }
      })
      this.dialogVisibleShow = false
      this.dialogVisibleShop = true
    },
  },
  beforeDestroy() {
    //清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style  scoped>
@import "@/assets/css/index.css";
@import "@/assets/css/left.css";
</style>